import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ScenarioLibrary from "../../../ngt/scenario/ScenarioLibrary";
import ChapterLibrary from "../../chapters/model/ChapterLibrary";
import MissionBriefingEvent from "../model/MissionBriefingEvent";

export default class PullMissionBriefingCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ChapterLibrary} chapterLibrary 
     * @param {ScenarioLibrary} scenarioLibrary 
     */
    constructor(dispatcher, chapterLibrary, scenarioLibrary) {
        super(dispatcher);

        this._chapterLibrary = chapterLibrary;
        this._scenarioLibrary = scenarioLibrary;

        this._handleMissionBriefingFinishBound = this._handleMissionBriefingFinish.bind(this);
    }

    execute(evt) {
        /** @type {MissionBriefingEvent} */
        const data = evt.params?.data;

        const scenario = this._scenarioLibrary.getCurrentScenario();

        this._briefingScreenSkin = this.openScreen(SkinKeyRegistry.MISSION_BRIEFING_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            allowClose: true,
            baseLpKey: `missionBriefings.${this._chapterLibrary.getCurrentChapter().id}.${scenario.id}`,
            backgroundImageId: scenario.missionBriefingBackgroundImageId,
        });

        this._dispatcher.addEventListener(MissionBriefingEvent.FINISH, this._handleMissionBriefingFinishBound);
    }

    _handleMissionBriefingFinish(evt) {
        this._dispatcher.removeEventListener(MissionBriefingEvent.FINISH, this._handleMissionBriefingFinishBound);

        this.closeScreen(this._briefingScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }
}